module.exports = __webpack_public_path__ + "static/media/videoCarousel.77069aeb.png";